import { useState } from 'react';
import { useIntl } from 'react-intl';
import {
  Box,
  Button,
  Checkbox,
  FormControlLabel,
  Typography,
} from '@material-ui/core';
import RejectOrderButton from './RejectOrderButton';

interface AcceptDecisionProps {
  orderNumber: string;
  canAccept: boolean;
  canReject: boolean;
  busy?: boolean;
  onAccept: () => unknown;
  onReject: (reason: string) => unknown;
}

// The consultant's decision under the conditions (change request of 06.10):
// Accept stays disabled until the consultant confirms having read the
// conditions, so nobody accepts by accident. Reject keeps its own bubble.
const AcceptDecision = ({
  orderNumber,
  canAccept,
  canReject,
  busy = false,
  onAccept,
  onReject,
}: AcceptDecisionProps) => {
  const intl = useIntl();
  const [confirmed, setConfirmed] = useState(false);

  if (!canAccept && !canReject) {
    return null;
  }

  return (
    <Box mt={2}>
      {canAccept && (
        <FormControlLabel
          control={
            <Checkbox
              id={`accept-confirm-${orderNumber}`}
              color="primary"
              checked={confirmed}
              onChange={(event) => setConfirmed(event.target.checked)}
            />
          }
          label={intl.formatMessage({ id: 'MY_ORDERS.ACCEPT_CONFIRM' })}
        />
      )}
      <Box display="flex" alignItems="center" flexWrap="wrap" gridGap={8}>
        {canAccept && (
          <Button
            color="primary"
            variant="contained"
            disabled={busy || !confirmed}
            onClick={() => onAccept()}
          >
            {intl.formatMessage({ id: 'MY_ORDERS.ACCEPT' })}
          </Button>
        )}
        {canReject && (
          <RejectOrderButton
            orderNumber={orderNumber}
            variant="outlined"
            busy={busy}
            onReject={onReject}
          />
        )}
        {canAccept && !confirmed && (
          <Typography variant="body2" color="textSecondary">
            {intl.formatMessage({ id: 'MY_ORDERS.ACCEPT_HINT' })}
          </Typography>
        )}
      </Box>
    </Box>
  );
};

export default AcceptDecision;
